import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ProgressService {
    inpregress: number = 0;
    private loaderSubject = new Subject<number>();
    loaderState = this.loaderSubject.asObservable();
    
    constructor() { }

    add() {
        this.loaderSubject.next(this.inpregress+= 1);
    }
    remove() {
        if (this.inpregress > 0)
            this.loaderSubject.next(this.inpregress-=1);
       
    }
    getInProgress() {
        return this.loaderSubject.asObservable();
    }
}
